import { Navigate, useLocation } from "react-router-dom";

/**
 * 301-style client redirect that preserves the query string and hash, so old
 * inbound links keep working after a route rename (P8: /ai → /meet-grok,
 * /features → /platform). e.g. /features#white-label → /platform#white-label.
 */
export function LegacyRedirect({ to }: { to: string }) {
    const { search, hash } = useLocation();
    return <Navigate to={`${to}${search}${hash}`} replace />;
}
